import { CheckboxGroup } from "@/react/components/SettingsApp/CompassCompat/CheckboxGroup";
import { Item } from "@/react/components/SettingsApp/CompassCompat/FormItem";
import { FormSelectNative } from "@/react/components/SettingsApp/CompassCompat/FormSelectNative";
import { FormToggleSwitch } from "@/react/components/SettingsApp/CompassCompat/FormToggleSwitch";
import { RadioGroup } from "@/react/components/SettingsApp/CompassCompat/RadioGroup";

import { Checkbox } from "./Checkbox";
import { Form as FormComponent } from "./Form";
import { FormInput } from "./FormInput";
import { FormLabel } from "./FormLabel";
import { FormSelect } from "./FormSelect";
import { FormTextArea } from "./FormTextArea";
import { FormTextSelect } from "./FormTextSelect";

export const Form = Object.assign(FormComponent, {
  Item,
  Label: FormLabel,
  Input: FormInput,
  TextArea: FormTextArea,
  Select: FormSelect,
  SelectNative: FormSelectNative,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  ToggleSwitch: FormToggleSwitch,
  TextSelect: FormTextSelect,
});
